module.exports = __webpack_public_path__ + "static/media/linked_list.61afc1fe.png";